import { Destroyer } from '@adaptiva/core/common';
import { Directive } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IProductNavigation, ProductNavigationService } from '../../navigation';
import { IHeaderLink } from '../interfaces/';

@Directive()
export abstract class BaseHeader extends Destroyer {

	public productNavigation$: BehaviorSubject<IProductNavigation[]> = new BehaviorSubject([]);

	public staticHeaderLinks: IHeaderLink[];

	constructor(protected _productNavigation: ProductNavigationService) {
		super();
	}

}
